<template>
  <div>
    <v-main>
      <v-container fluid class="pa-6">
        <!-- Header Section -->
        <v-row align="center" class="mb-4">
          <v-col cols="12" md="6">
            <div class="d-flex align-center">
              <v-icon large color="primary" class="mr-3">mdi-taxi</v-icon>
              <div>
                <h1 class="text-h4 font-weight-bold primary--text">ข้อมูล Taxi</h1>
                <p class="text-subtitle-1 mb-0 text--secondary">จัดการข้อมูลคนขับและรถแท็กซี่</p>
              </div>
            </div>
          </v-col>
          <v-col cols="12" md="6" class="text-md-right">
            <v-btn
              color="primary"
              large
              elevation="2"
              @click="openAddDialog"
            >
              <v-icon left>mdi-plus-circle</v-icon>
              เพิ่มรายชื่อ
            </v-btn>
          </v-col>
        </v-row>

        <!-- Add Dialog -->
        <v-dialog v-model="dialogAdd" max-width="600px" persistent>
          <v-card>
            <v-form ref="form_add" v-model="validAdd" lazy-validation>
              <v-card-title class="primary white--text">
                <v-icon left color="white">mdi-account-plus</v-icon>
                <span class="text-h5">เพิ่มรายชื่อคนขับ</span>
                <v-spacer></v-spacer>
                <v-btn icon dark @click="closeAddDialog">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-card-title>
              <v-card-text class="pt-6">
                <v-container>
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                        v-model="formAdd.driverName"
                        label="ชื่อ-นามสกุล"
                        prepend-icon="mdi-account"
                        outlined
                        dense
                        :rules="[v => !!v || 'กรุณากรอกชื่อ']"
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        v-model="formAdd.phoneNum"
                        label="เบอร์โทรศัพท์"
                        prepend-icon="mdi-phone"
                        outlined
                        dense
                        :rules="[v => !!v || 'กรุณากรอกเบอร์โทรศัพท์']"
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        v-model="formAdd.licensePlate"
                        label="ทะเบียนรถ"
                        prepend-icon="mdi-card-account-details"
                        outlined
                        dense
                        :rules="[v => !!v || 'กรุณากรอกทะเบียนรถ']"
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        v-model="formAdd.driverLicense"
                        label="เลขที่ใบขับขี่"
                        prepend-icon="mdi-card-account-details-outline"
                        outlined
                        dense
                        :rules="[v => !!v || 'กรุณากรอกเลขที่ใบขับขี่']"
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-select
                        v-model="formAdd.typeCar"
                        :items="typeCarData"
                        label="ประเภทรถ"
                        prepend-icon="mdi-car"
                        outlined
                        dense
                        :rules="[v => !!v || 'กรุณาเลือกประเภทรถ']"
                        required
                      ></v-select>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions class="pa-4">
                <v-spacer></v-spacer>
                <v-btn
                  color="grey"
                  text
                  large
                  @click="closeAddDialog"
                >
                  <v-icon left>mdi-close</v-icon>
                  ยกเลิก
                </v-btn>
                <v-btn
                  color="primary"
                  large
                  elevation="2"
                  :loading="loading"
                  @click="validate('ADD')"
                >
                  <v-icon left>mdi-content-save</v-icon>
                  บันทึก
                </v-btn>
              </v-card-actions>
            </v-form>
          </v-card>
        </v-dialog>

        <!-- Update Dialog -->
        <v-dialog v-model="dialogUpdate" max-width="600px" persistent>
          <v-card>
            <v-form ref="form_update" v-model="validUpdate" lazy-validation>
              <v-card-title class="orange white--text">
                <v-icon left color="white">mdi-pencil</v-icon>
                <span class="text-h5">แก้ไขข้อมูลคนขับ</span>
                <v-spacer></v-spacer>
                <v-btn icon dark @click="closeUpdateDialog">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-card-title>
              <v-card-text class="pt-6">
                <v-container>
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                        v-model="formUpdate.driverName"
                        label="ชื่อ-นามสกุล"
                        prepend-icon="mdi-account"
                        outlined
                        dense
                        :rules="[v => !!v || 'กรุณากรอกชื่อ']"
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        v-model="formUpdate.phoneNum"
                        label="เบอร์โทรศัพท์"
                        prepend-icon="mdi-phone"
                        outlined
                        dense
                        :rules="[v => !!v || 'กรุณากรอกเบอร์โทรศัพท์']"
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        v-model="formUpdate.licensePlate"
                        label="ทะเบียนรถ"
                        prepend-icon="mdi-card-account-details"
                        outlined
                        dense
                        :rules="[v => !!v || 'กรุณากรอกทะเบียนรถ']"
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        v-model="formUpdate.driverLicense"
                        label="เลขที่ใบขับขี่"
                        prepend-icon="mdi-card-account-details-outline"
                        outlined
                        dense
                        :rules="[v => !!v || 'กรุณากรอกเลขที่ใบขับขี่']"
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-select
                        v-model="formUpdate.typeCar"
                        :items="typeCarData"
                        label="ประเภทรถ"
                        prepend-icon="mdi-car"
                        outlined
                        dense
                        :rules="[v => !!v || 'กรุณาเลือกประเภทรถ']"
                        required
                      ></v-select>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions class="pa-4">
                <v-spacer></v-spacer>
                <v-btn
                  color="grey"
                  text
                  large
                  @click="closeUpdateDialog"
                >
                  <v-icon left>mdi-close</v-icon>
                  ยกเลิก
                </v-btn>
                <v-btn
                  color="orange"
                  large
                  dark
                  elevation="2"
                  :loading="loading"
                  @click="validate('UPDATE')"
                >
                  <v-icon left>mdi-content-save</v-icon>
                  บันทึก
                </v-btn>
              </v-card-actions>
            </v-form>
          </v-card>
        </v-dialog>

        <!-- Main Content Card -->
        <v-card elevation="3" class="rounded-lg">
          <v-card-title class="pb-0">
            <v-text-field
              v-model="searchAll2"
              append-icon="mdi-magnify"
              label="ค้นหา..."
              single-line
              outlined
              dense
              hide-details
              clearable
              class="mb-4"
            ></v-text-field>
          </v-card-title>
          <v-card-text class="pa-0">
            <v-data-table
              :headers="headers"
              :search="searchAll2"
              :items="data"
              :loading="loading"
              loading-text="กำลังโหลดข้อมูล..."
              no-data-text="ไม่มีข้อมูล"
              class="elevation-0"
              :items-per-page="10"
              :footer-props="{
                'items-per-page-text': 'แถวต่อหน้า:',
                'items-per-page-options': [10, 20, 50, 100]
              }"
            >
              <template v-slot:[`item.driverName`]="{ item }">
                <div class="d-flex align-center py-2">
                  <v-avatar color="primary" size="36" class="mr-3">
                    <v-icon dark small>mdi-account</v-icon>
                  </v-avatar>
                  <span class="font-weight-medium">{{ item.driverName }}</span>
                </div>
              </template>

              <template v-slot:[`item.phoneNum`]="{ item }">
                <v-chip small color="blue lighten-5" class="blue--text text--darken-2">
                  <v-icon small left>mdi-phone</v-icon>
                  {{ item.phoneNum }}
                </v-chip>
              </template>

              <template v-slot:[`item.licensePlate`]="{ item }">
                <v-chip small color="green lighten-5" class="green--text text--darken-2">
                  <v-icon small left>mdi-car</v-icon>
                  {{ item.licensePlate }}
                </v-chip>
              </template>

              <template v-slot:[`item.typeCar`]="{ item }">
                <v-chip
                  small
                  :color="item.typeCar === '4 ที่นั่ง' ? 'purple lighten-5' : 'orange lighten-5'"
                  :class="item.typeCar === '4 ที่นั่ง' ? 'purple--text text--darken-2' : 'orange--text text--darken-2'"
                >
                  {{ item.typeCar }}
                </v-chip>
              </template>

              <template v-slot:[`item.action`]="{ item }">
                <v-btn
                  color="orange"
                  dark
                  small
                  elevation="2"
                  @click="openUpdateDialog(item)"
                >
                  <v-icon small left>mdi-pencil</v-icon>
                  แก้ไข
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-container>
    </v-main>
  </div>
</template>
<script>
import axios from 'axios' // api
import adminLeftMenu from '../Sidebar.vue' // เมนู
export default {
  components: {
    'left-menu-admin': adminLeftMenu
  },
  data () {
    return {
      validAdd: true,
      validUpdate: true,
      dialogAdd: false,
      dialogUpdate: false,
      loading: false,
      searchAll2: '',
      data: [],
      headers: [
        { text: 'ชื่อ', value: 'driverName', align: 'left' },
        { text: 'เบอร์โทรศัพท์', value: 'phoneNum', align: 'center' },
        { text: 'ทะเบียนรถ', value: 'licensePlate', align: 'center' },
        { text: 'เลขที่ใบขับขี่', value: 'driverLicense', align: 'center' },
        { text: 'ประเภทรถ', value: 'typeCar', align: 'center' },
        { text: 'จัดการ', value: 'action', sortable: false, align: 'center' }
      ],
      breadcrumbs: [
        {
          text: 'ข้อมูล Taxi'
        }
      ],
      typeCarData: [
        {
          value: '4 ที่นั่ง',
          text: '4 ที่นั่ง'
        },
        {
          value: '7 ที่นั่ง',
          text: '7 ที่นั่ง'
        }
      ],
      formAdd: {
        driverName: '',
        phoneNum: '',
        licensePlate: '',
        driverLicense: '',
        typeCar: ''
      },
      formUpdate: {
        driverName: '',
        phoneNum: '',
        licensePlate: '',
        driverLicense: '',
        typeCar: ''
      }
    }
  },
  async mounted () {
    this.getData()
  },
  methods: {
    getData () {
      this.loading = true
      this.data = []
      axios.get(`${this.$DNS_IP}/data_taxi_202511/getNoBooking?RECORD_STATUS=N`)
        .then(response => {
          if (response.data.length > 0) {
            this.data = response.data
          }
        })
        .catch(error => {
          this.data = []
          console.log(error)
        })
        .finally(() => {
          this.loading = false
        })
    },
    openAddDialog () {
      this.formAdd = {
        driverName: '',
        phoneNum: '',
        licensePlate: '',
        driverLicense: '',
        typeCar: ''
      }
      this.dialogAdd = true
    },
    closeAddDialog () {
      this.dialogAdd = false
      if (this.$refs.form_add) {
        this.$refs.form_add.resetValidation()
      }
    },
    openUpdateDialog (item) {
      this.formUpdate = Object.assign({}, item)
      this.dialogUpdate = true
    },
    closeUpdateDialog () {
      this.dialogUpdate = false
      if (this.$refs.form_update) {
        this.$refs.form_update.resetValidation()
      }
    },
    addData () {
      // Validate form first
      if (this.$refs.form_add && !this.$refs.form_add.validate()) {
        return
      }

      this.$swal({
        title: 'ต้องการเพิ่มข้อมูลใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ยกเลิก'
      }).then((result) => {
        if (result) {
          this.loading = true
          axios.post(`${this.$DNS_IP}/data_taxi_202511/add`, this.formAdd)
            .then(response => {
              this.$swal('สำเร็จ', 'เพิ่มข้อมูลเรียบร้อย', 'success')
              this.closeAddDialog()
              // Reload data
              this.getData()
            })
            .catch(error => {
              console.log(error)
              this.$swal('ผิดพลาด', 'ไม่สามารถเพิ่มข้อมูลได้', 'error')
            })
            .finally(() => {
              this.loading = false
            })
        }
      })
    },
    updateData () {
      // Validate form first
      if (this.$refs.form_update && !this.$refs.form_update.validate()) {
        return
      }

      // ตรวจสอบว่ามี id หรือไม่
      if (!this.formUpdate.id) {
        this.$swal('ผิดพลาด', 'ไม่พบ ID ของข้อมูล', 'error')
        return
      }

      this.$swal({
        title: 'ต้องการแก้ไขข้อมูลใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ยกเลิก'
      }).then((result) => {
        if (result) {
          this.loading = true
          const dataToUpdate = {
            driverName: this.formUpdate.driverName,
            phoneNum: this.formUpdate.phoneNum,
            licensePlate: this.formUpdate.licensePlate,
            driverLicense: this.formUpdate.driverLicense,
            typeCar: this.formUpdate.typeCar
          }

          axios.post(`${this.$DNS_IP}/data_taxi_202511/edit/${this.formUpdate.id}`, dataToUpdate)
            .then(response => {
              this.$swal('สำเร็จ', 'แก้ไขข้อมูลเรียบร้อย', 'success')
              this.closeUpdateDialog()
              // Reload data
              this.getData()
            })
            .catch(error => {
              console.log(error)
              this.$swal('ผิดพลาด', 'ไม่สามารถแก้ไขข้อมูลได้', 'error')
            })
            .finally(() => {
              this.loading = false
            })
        }
      })
    },
    validate (Action) {
      switch (Action) {
        case 'ADD':
          this.addData()
          break
        case 'UPDATE':
          this.updateData()
          break
        default:
          break
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Master/Manage_Data_Taxi.vue